export default "__VITE_ASSET__fXW9tssf__"